import { render, staticRenderFns } from "./ERP-PreviewPDF.vue?vue&type=template&id=36f19bc6&"
import script from "./ERP-PreviewPDF.vue?vue&type=script&lang=js&"
export * from "./ERP-PreviewPDF.vue?vue&type=script&lang=js&"
import style0 from "./ERP-PreviewPDF.vue?vue&type=style&index=0&id=36f19bc6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports